// FIGYELEM: az alkalmazás (src/components/Court.vue) EZT a fájlt importálja. A
// ../src alatti TypeScript a logika leírása; ezt a fájlt kézzel tartjuk
// karban (export, willReadFrequently, 78. tétel), a tsc kimenete nem írhatja felül.
import COLOR_MAP_DATA_URL from './colorMapData';
class Area {
    constructor(id, color, colorRight, selectedImg, selectedImgRight, isBtn) {
        this._color = color;
        this._id = id;
        this._selectedImg = selectedImg;
        this._isBtn = isBtn;
        this._colorRight = colorRight;
        this._selectedImgRight = selectedImgRight;
    }
    get color() {
        return this._color;
    }
    get id() {
        return this._id;
    }
    get selectedImg() {
        return this._selectedImg;
    }
    get isBtn() {
        return this._isBtn;
    }
    get colorRight() {
        return this._colorRight;
    }
    get selectedImgRight() {
        return this._selectedImgRight;
    }
}
// JAVÍTÁS (78. tétel - 32021458074): a pálya a koppintás helyét egy rejtett
// canvasra rajzolt színtérképből olvassa ki. A meccsen (iPad, Chrome, memória-
// nyomás, 2 mp-es fehér villanás) ez a canvas láthatóan kiürült: onnantól
// MINDEN koppintás "nem talált területet", hibaüzenet nélkül, és csak az oldal
// újratöltése / böngészőváltás segített. Mostantól:
//  - a színtérkép a programba ágyazott (colorMapData.js), hálózat nem kell hozzá;
//    a régi URL csak tartalék, ha a beágyazott kép valamiért nem töltene be;
//  - minden koppintás előtt olcsó állapotellenőrzés: a PNG-nek nincs alfa-
//    csatornája, egy ép canvason tehát MINDEN pixel alfája 255, és a középpont
//    színe azonos az első betöltéskor mérttel; ha nem, a canvast a memóriában
//    lévő képből újraépítjük, és a koppintást megismételjük;
//  - a 'contextlost' eseményt (ahol a böngésző támogatja) is figyeljük.
class ColorMap {
    static init(sources) {
        ColorMap._sources = (Array.isArray(sources) ? sources : [sources]).filter(Boolean);
        ColorMap._lost = false;
        if (ColorMap._img && ColorMap._img.complete && ColorMap._img.naturalWidth > 0) {
            return Promise.resolve(ColorMap.draw());
        }
        return ColorMap.load(0);
    }
    static load(index) {
        return new Promise(function (resolve) {
            const src = ColorMap._sources ? ColorMap._sources[index] : null;
            if (!src) {
                console.error('errol loading image');
                resolve(false);
                return;
            }
            const img = document.createElement('img');
            img.onload = function () {
                ColorMap._img = img;
                resolve(ColorMap.draw());
            };
            img.onerror = function () {
                ColorMap.load(index + 1).then(resolve);
            };
            img.src = src;
        });
    }
    // A (már betöltött, memóriában lévő) képből új canvast rajzol. Szinkron.
    static draw() {
        const img = ColorMap._img;
        if (!img || !img.naturalWidth || !img.naturalHeight) {
            return false;
        }
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext('2d', { willReadFrequently: true });
        if (!ctx) {
            return false;
        }
        canvas.addEventListener('contextlost', function () {
            ColorMap._lost = true;
        });
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ColorMap.CTX = ctx;
        ColorMap._lost = false;
        if (!ColorMap._referenceColor) {
            const ref = ColorMap.readCenter();
            if (ref && ref.a === 255) {
                ColorMap._referenceColor = ref.hex;
            }
        }
        return ColorMap.isHealthy();
    }
    static readCenter() {
        try {
            const c = ColorMap.CTX.canvas;
            const d = ColorMap.CTX.getImageData(Math.floor(c.width / 2), Math.floor(c.height / 2), 1, 1).data;
            return { hex: ColorMap.rgbToHex(d[0], d[1], d[2]), a: d[3] };
        }
        catch (e) {
            return null;
        }
    }
    static isHealthy() {
        if (!ColorMap.CTX || ColorMap._lost) {
            return false;
        }
        const c = ColorMap.CTX.canvas;
        if (!c || !c.width || !c.height) {
            return false;
        }
        const center = ColorMap.readCenter();
        return !!center && center.a === 255 && (!ColorMap._referenceColor || center.hex === ColorMap._referenceColor);
    }
    // Újraépítés: előbb a memóriában lévő képből (szinkron, hálózat nélkül),
    // ha az nem sikerül, a forrásokból újratöltve.
    static rebuild() {
        if (ColorMap.draw()) {
            return Promise.resolve(true);
        }
        return ColorMap.load(0);
    }
    static getPixelAt(x, y, direction) {
        const c = ColorMap.CTX.canvas;
        let modX = x;
        if (direction == Direction.RIGHT) {
            modX = c.width - x;
        }
        const inBounds = modX >= 0 && y >= 0 && modX < c.width && y < c.height;
        const d = ColorMap.CTX.getImageData(modX, y, 1, 1).data;
        return { hex: ColorMap.rgbToHex(d[0], d[1], d[2]), a: d[3], inBounds: inBounds };
    }
    static getIdAtCoords(x, y, direction) {
        return ColorMap.getPixelAt(x, y, direction).hex;
    }
    static rgbToHex(r, g, b) {
        let hexString = "#";
        hexString += ColorMap.hexCodes.charAt(Math.floor(r / 16));
        hexString += ColorMap.hexCodes.charAt(r % 16);
        hexString += ColorMap.hexCodes.charAt(Math.floor(g / 16));
        hexString += ColorMap.hexCodes.charAt(g % 16);
        hexString += ColorMap.hexCodes.charAt(Math.floor(b / 16));
        hexString += ColorMap.hexCodes.charAt(b % 16);
        return hexString;
    }
    static get size() {
        return [ColorMap.CTX.canvas.width, ColorMap.CTX.canvas.height];
    }
}
ColorMap.hexCodes = "0123456789ABCDEF";
// Ennyi egymás utáni, területet nem találó koppintás után szólunk (l. registerMiss).
const MISS_STREAK_WARN = 3;
const MISS_STREAK_RESET_MS = 20000;
export class CourtCanvas {
    constructor(initData) {
        this._selectedId = null;
        this._enabled = true;
        this._missStreak = 0;
        this._lastMissAt = 0;
        this._data = new InitData(initData);
        ColorMap.init([COLOR_MAP_DATA_URL, this._data.assetFolder + '/' + this._data.colorMap]);
        this.createDivs();
        this.setStyles();
        this._data.parentDiv.addEventListener("mouseup", this.mouseUp.bind(this));
    }
    get ar() {
        return this._data.parentDiv.offsetWidth / ColorMap.size[0];
    }
    setImgUrls() {
        this.clear();
        this._backgroundDiv.style.backgroundImage = 'url("' + this._data.assetFolder + '/' + this._data.theme + '/' + this._data.direction + '/' + this._data.backgroundImg + '")';
        this._linesDiv.style.backgroundImage = 'url("' + this._data.assetFolder + '/' + this._data.theme + '/' + this._data.direction + '/' + this._data.linesImg + '")';
        if (this._selectedId != null) {
            this.drawSelectedId(this._selectedId);
        }
    }
    createDivs() {
        this._backgroundDiv = document.createElement('div');
        this._backgroundDiv.id = "Background";
        this._backgroundDiv.classList.add('imageDiv');
        this._data.parentDiv.appendChild(this._backgroundDiv);
        this._selectionFieldDiv = document.createElement('div');
        this._selectionFieldDiv.id = "SelectedArea";
        this._selectionFieldDiv.classList.add('imageDiv');
        this._data.parentDiv.appendChild(this._selectionFieldDiv);
        this._linesDiv = document.createElement('div');
        this._linesDiv.id = "Lines";
        this._linesDiv.classList.add('imageDiv');
        this._data.parentDiv.appendChild(this._linesDiv);
        this._selectionButtonDiv = document.createElement('div');
        this._selectionButtonDiv.id = "SelectedBtn";
        this._selectionButtonDiv.classList.add('imageDiv');
        this._data.parentDiv.appendChild(this._selectionButtonDiv);
    }
    changeTheme(theme) {
        this._data.theme = theme;
        this.setImgUrls();
    }
    setStyles() {
        this._backgroundDiv.style.width = this._backgroundDiv.style.height = '100%';
        this._linesDiv.style.width = this._linesDiv.style.height = '100%';
        this._selectionButtonDiv.style.width = this._selectionButtonDiv.style.height = '100%';
        this._selectionFieldDiv.style.width = this._selectionFieldDiv.style.height = '100%';
        this._backgroundDiv.style.backgroundSize = 'contain';
        this._linesDiv.style.backgroundSize = 'contain';
        this._selectionButtonDiv.style.backgroundSize = 'contain';
        this._selectionFieldDiv.style.backgroundSize = 'contain';
        this._backgroundDiv.style.backgroundRepeat = 'no-repeat';
        this._linesDiv.style.backgroundRepeat = 'no-repeat';
        this._selectionButtonDiv.style.backgroundRepeat = 'no-repeat';
        this._selectionFieldDiv.style.backgroundRepeat = 'no-repeat';
        this._backgroundDiv.style.position = 'absolute';
        this._linesDiv.style.position = 'absolute';
        this._selectionButtonDiv.style.position = 'absolute';
        this._selectionFieldDiv.style.position = 'absolute';
    }
    mouseUp(e) {
        if (!this._enabled)
            return;
        let clientRect = this._data.parentDiv.getBoundingClientRect();
        let x = e.pageX - clientRect.left - window.scrollX;
        let y = e.pageY - clientRect.top - window.scrollY;
        this.handleTap(x, y, false);
    }
    handleTap(x, y, isRetry) {
        if (!this._enabled)
            return;
        if (!ColorMap.isHealthy()) {
            // A színtérkép nem olvasható (még nem töltött be, vagy a böngésző
            // elengedte a canvas tartalmát): újraépítjük, és a koppintást egyszer
            // megismételjük - a felhasználónak nem kell újra koppintania.
            const center = ColorMap.CTX ? ColorMap.readCenter() : null;
            this.diagnostic('colormap-unhealthy', { retry: isRetry, center: center });
            if (isRetry) {
                this.registerMiss('unhealthy');
                return;
            }
            ColorMap.rebuild().then((ok) => {
                this.diagnostic(ok ? 'colormap-rebuilt' : 'colormap-rebuild-failed', {});
                this.handleTap(x, y, true);
            });
            return;
        }
        const ar = this.ar;
        const pixel = ColorMap.getPixelAt(x / ar, y / ar, this._data.direction);
        const foundId = pixel.a === 255 ? this.getIdByColor(pixel.hex) : null;
        if (foundId != null) {
            this._missStreak = 0;
            if (foundId == this._selectedId) {
                this.init(this._data.direction);
                this._data.onSelect(null);
            }
            else {
                this.init(this._data.direction, foundId);
                this._data.onSelect(foundId);
            }
        }
        else {
            // 'no-area': a semleges (fehér) zóna; 'out-of-bounds': a kép mellé;
            // 'transparent': ép canvas mellett nem fordulhatna elő.
            const reason = !pixel.inBounds ? 'out-of-bounds' : (pixel.a !== 255 ? 'transparent' : 'no-area');
            this.registerMiss(reason, pixel);
        }
    }
    registerMiss(reason, pixel) {
        const now = Date.now();
        if (now - this._lastMissAt > MISS_STREAK_RESET_MS) {
            this._missStreak = 0;
        }
        this._missStreak++;
        this._lastMissAt = now;
        if (this._missStreak % MISS_STREAK_WARN === 0) {
            this.diagnostic('miss-streak', { reason: reason, count: this._missStreak, pixel: pixel || null });
            if (typeof this._data.onWarning === 'function') {
                try {
                    this._data.onWarning(reason, this._missStreak);
                }
                catch (e) {
                    console.error(e);
                }
            }
        }
    }
    diagnostic(type, meta) {
        if (typeof this._data.onDiagnostic !== 'function')
            return;
        try {
            const c = ColorMap.CTX ? ColorMap.CTX.canvas : null;
            this._data.onDiagnostic(type, Object.assign({
                canvasWidth: c ? c.width : null,
                canvasHeight: c ? c.height : null,
                parentWidth: this._data.parentDiv ? this._data.parentDiv.offsetWidth : null,
                direction: this._data.direction
            }, meta || {}));
        }
        catch (e) {
            console.error(e);
        }
    }
    disable() {
        this._data.parentDiv.style.opacity = '.5';
        this._enabled = false;
    }
    enable() {
        this._data.parentDiv.style.opacity = '1';
        this._enabled = true;
    }
    init(direction, areaId = null) {
        this._data.direction = direction;
        this.setImgUrls();
        this.enable();
        this._selectedId = areaId;
        if (this._selectedId == null) {
            this.clear();
        }
        else {
            this.drawSelectedId(this._selectedId);
        }
    }
    clear() {
        this._selectionFieldDiv.style.backgroundImage = "";
        this._selectionButtonDiv.style.backgroundImage = "";
    }
    getIdByColor(color) {
        for (let i = 0; i < this._data.areas.length; i++) {
            if (this._data.direction == Direction.LEFT) {
                if (this._data.areas[i].color.toLocaleLowerCase() == color.toLocaleLowerCase()) {
                    return this._data.areas[i].id;
                }
            }
            else {
                if (this._data.areas[i].colorRight.toLocaleLowerCase() == color.toLocaleLowerCase()) {
                    return this._data.areas[i].id;
                }
            }
        }
        return null;
    }
    drawSelectedId(id) {
        for (let i = 0; i < this._data.areas.length; i++) {
            if (this._data.areas[i].id == id) {
                this.clear();
                let imgName;
                if (this._data.direction == Direction.LEFT) {
                    imgName = this._data.areas[i].selectedImg;
                }
                else {
                    imgName = this._data.areas[i].selectedImgRight;
                }
                if (this._data.areas[i].isBtn) {
                    this._selectionButtonDiv.style.backgroundImage = 'url(' + this._data.assetFolder + '/' + this._data.theme + '/' + this._data.direction + '/' + imgName + ')';
                }
                else {
                    this._selectionFieldDiv.style.backgroundImage = 'url(' + this._data.assetFolder + '/' + this._data.theme + '/' + this._data.direction + '/' + imgName + ')';
                }
                break;
            }
        }
    }
}
var Direction;
(function (Direction) {
    Direction["LEFT"] = "left";
    Direction["RIGHT"] = "right";
})(Direction || (Direction = {}));
var Theme;
(function (Theme) {
    Theme["DARK"] = "dark";
    Theme["LIGHT"] = "light";
})(Theme || (Theme = {}));
class InitData {
    constructor(initObject) {
        this._parentDiv = initObject["parentDiv"];
        this._onSelect = initObject["onSelect"];
        // 78. tétel: diagnosztika (Bugsnag) és felhasználói figyelmeztetés - mindkettő opcionális
        this._onDiagnostic = initObject["onDiagnostic"];
        this._onWarning = initObject["onWarning"];
        this._backgroundImg = initObject["backgroundImg"];
        this._linesImg = initObject["linesImg"];
        this._colorMap = initObject["colorMap"];
        this._colorMap = initObject["colorMap"];
        this._theme = initObject["theme"];
        this._assetFolder = initObject["assetFolder"];
        this._areas = [];
        let area;
        let id;
        let color;
        let colorR;
        let selectedImg;
        let selectedImgR;
        let isBtn;
        for (let i = 0; i < initObject["area"]["length"]; i++) {
            id = initObject["area"][i]["id"];
            color = initObject["area"][i]["color"];
            colorR = initObject["area"][i]["colorRight"];
            selectedImg = initObject["area"][i]["selectedImg"];
            selectedImgR = initObject["area"][i]["selectedImgRight"];
            isBtn = initObject["area"][i]["isBtn"];
            area = new Area(id, color, colorR, selectedImg, selectedImgR, isBtn);
            this._areas.push(area);
        }
    }
    get parentDiv() {
        return this._parentDiv;
    }
    get onSelect() {
        return this._onSelect;
    }
    get onDiagnostic() {
        return this._onDiagnostic;
    }
    get onWarning() {
        return this._onWarning;
    }
    get backgroundImg() {
        return this._backgroundImg;
    }
    get linesImg() {
        return this._linesImg;
    }
    get colorMap() {
        return this._colorMap;
    }
    get areas() {
        return this._areas;
    }
    get direction() {
        return this._direction;
    }
    set direction(value) {
        this._direction = value;
    }
    get theme() {
        return this._theme;
    }
    set theme(value) {
        this._theme = value;
    }
    get assetFolder() {
        return this._assetFolder;
    }
}

export default CourtCanvas;